export default {
  install(Vue) {
    // 全局的Vue mixin方法，好处是不用每个组件自己去处理注入方法
    Vue.mixin({
      watch: {
        ['$options.documentTitle'](val) {
          this.setDocumentTitle(val);
        }
      },
      created() {
        this.setDocumentTitle(this.$options.documentTitle);
      },
      methods: {
        setDocumentTitle(documentTitle) {
          if (documentTitle) {
            // 获取组件下定义的 documentTitle 自定义属性
            const titleType = typeof documentTitle
            if (['string', 'function'].indexOf(titleType) !== -1) {
              this.updateDocumentTitle(titleType === 'function' ?
                  documentTitle.call(this) : documentTitle);
            } else if (titleType === 'object' && documentTitle.i18n) {
              this.updateDocumentTitle(this.$t(documentTitle.i18n));
            }
          }
        },
        updateDocumentTitle(__title) {
          document.title = __title;
        }
      }
    })
  }
}
